import { FleetTireAddRow } from "services/api/fleet/tires/types";

export interface TireGroup {
    indices: number[];
    tires: FleetTireAddRow[];
}

const FRONT_LABELS = ["Prednja lijeva", "Prednja desna"];
const REAR_LABELS = ["Stražnja lijeva", "Stražnja desna"];

export const groupByDimensions = (tires: FleetTireAddRow[]): TireGroup[] => {
    const key = (t: FleetTireAddRow) => `${t.width}-${t.height}-${t.radius}`;
    const groups = new Map<string, TireGroup>();
    tires.forEach((tire, i) => {
        const k = key(tire);
        if (!groups.has(k)) groups.set(k, { indices: [], tires: [] });
        groups.get(k)!.indices.push(i);
        groups.get(k)!.tires.push(tire);
    });
    return Array.from(groups.values());
};

export const getTireLabel = (index: number, total: number): string => {
    if (total === 4) {
        return [...FRONT_LABELS, ...REAR_LABELS][index];
    }
    return `Guma ${index + 1}`;
};

export const getGroupLabel = (groupIndex: number, totalGroups: number): string => {
    if (totalGroups <= 2) {
        return groupIndex === 0 ? "Prednja osovina" : "Stražnja osovina";
    }
    return `Osovina ${groupIndex + 1}`;
};
